import { createAction, props } from '@ngrx/store';

export const getReviewer = createAction('getReviewer');
export const setReviewer = createAction('setReviewer', props<any>());
export const reloadReviewer = createAction('reloadReviewer', props<any>());
export const removeReviewer = createAction('removeReviewer');